export default "__VITE_PUBLIC_ASSET__73dc74c5__"